/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Plugins
import { VueQueryPlugin } from "@tanstack/vue-query"
import pinia from "./pinia"
import vuetify from "./vuetify"
import router from "./router"
import datadog from "./datadog"
import { provide } from "./provide"

// Types
import type { App } from "vue"

export function registerPlugins(app: App) {
  app.use(datadog)
  app.use(pinia)
  app.use(vuetify)
  app.use(router)
  app.use(VueQueryPlugin)
  app.use(provide)
}
